import React from "react";
import MainLayout from "../../components/layout/MainLayout";

// Recycle content component
const RecycleContent = () => {
  return (
    <div className="w-full bg-guru-floral-white min-h-screen p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header section with icon and title */}
        <div className="bg-[#FFF5F1] rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
          <div className="flex items-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#C4704B] rounded-lg flex items-center justify-center mr-3 sm:mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-6 h-6 sm:w-8 sm:h-8">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </svg>
            </div>
            <span className="text-lg sm:text-xl font-semibold">環保行動</span>
          </div>
        </div>

        <h1 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">回收須知</h1>

        <div className="space-y-4 sm:space-y-6">
          <div>
            <h2 className="text-[#6B7AAC] font-semibold mb-3 sm:mb-4">關於環保配送服務(必須睇)</h2>

            <div className="space-y-4 sm:space-y-6 font-medium">
              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q.咩係環保配送服務？</h3>
                <p className="text-sm sm:text-base">
                  A.
                  環保配送服務係一個提供比係GuruGuru購物既免費服務，於GuruGuruhk.com網站購物後，司機送貨上門既同時，可以將已經處理好既回收物交比司機。
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q.可以叫司機等我即時拆箱/包裝嗎？</h3>
                <p className="text-sm sm:text-base">
                  A.❌唔可以🙏🏻因為司機每日好多order要送，如果每位客人都要等拆箱/包裝，司機每日起碼要ot幾個鐘
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q.點先㨂到環保配送服務？</h3>
                <p className="text-sm sm:text-base">
                  A.
                  於GuruGuruhk.com網站購物滿$450(以最終結帳計，唔准嘥嘢及義賣不計算在內)，埋單第一版送貨方式選擇「環保配送服務」
                </p>
                <p className="mt-2 text-sm sm:text-base">*唔夠$450會額外收$50運費</p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 環保配送服務收啲乜？</h3>
                <p className="text-sm sm:text-base">A. Guru環保配送服務主要收幾類物資(非以下種類物品一律唔收)：</p>

                <div className="mt-4 space-y-4 sm:space-y-6">
                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      1️⃣膠(1號膠(大部份飲品樽), 2號膠(大部份日用品樽), 雜膠-包括各種樽蓋，無標明幾號的膠，外賣盒之類)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">‼️客人需清洗乾淨後，根據以上3大類分開放</p>
                    <p className="mt-2 text-sm sm:text-base">
                      ⚠️注意：就算外包裝有recycle 標誌，招紙，膠袋，軟膠，發泡膠，食物包裝袋一律❌唔收
                    </p>
                    <p className="mt-2 text-sm sm:text-base">膠樽招紙如何處理</p>
                    <p className="mt-2 text-sm sm:text-base">請參考</p>
                    <div className="text-[#C4704B] hover:underline">
                      <a
                        href="https://www.facebook.com/512793125803793/posts/945367282546373/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm sm:text-base"
                      >
                        video: https://www.facebook.com/512793125803793/posts/945367282546373/
                      </a>
                    </div>
                    <div className="text-[#C4704B] hover:underline mt-2">
                      <a
                        href="https://www.facebook.com/512793125803793/posts/1032364473846653/?d=n"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm sm:text-base"
                      >
                        Photo: https://www.facebook.com/512793125803793/posts/1032364473846653/?d=n
                      </a>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      2️⃣紙(有鋁紙飲品盒，全白色牛奶盒，其他無被污染嘅紙類（過膠，痴了膠的紙，貼紙，包左膠，有透明膠窗的信封，熱感紙。除外）所有紙包飲品盒如有膠蓋必須剪走)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">‼️客人需清洗乾淨後，根據以上3大類分開放</p>
                    <p className="mt-2 text-sm sm:text-base">想知飲品盒點樣正確處理可以參考以下短片</p>
                    <div className="text-[#C4704B] hover:underline">
                      <a
                        href="https://www.facebook.com/862368870441741/posts/3449095245102411/?vh=e"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm sm:text-base"
                      >
                        請參考 https://www.facebook.com/862368870441741/posts/3449095245102411/?vh=e
                      </a>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      3️⃣玻璃(只限客人係Guru購買既產品，例如悅和、大杯茶，藍象等等.....)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️由於玻璃需特別存放，所以其他Guru無賣既產品玻璃樽一律唔收，以免形響倉存空間
                    </p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">4️⃣金屬(所有金屬類都收)</p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️電器或混有其他物料既，除非你已經拆開，分成唔同物料，否則唔好比我地
                    </p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      5️⃣冰種(任何類型，品牌，大細，無爛都收，必需要預先溶雪、抺乾淨)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️冰種無得直接回收，Guru回收番嚟重用，令佢哋有多一次，甚至更多次既生命
                    </p>
                    <p className="mt-2 text-sm sm:text-base">
                      ⚠️注意：由於未溶雪既冰種會出水，放係司機車有機會發霉同滋生細菌，所以必需要預先溶雪、抺乾淨，否則倉同事會多好多功夫
                      (亦係點解唔可以即時拆包裝還比司機其中一個原因)
                    </p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      6️⃣冰袋(保溫袋)(任何類型，品牌，大細，無爛都收，必需要乾淨)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️冰袋無得直接回收，Guru回收番嚟重用，令佢哋有多一次，甚至更多次既生命
                    </p>
                    <p className="mt-2 text-sm sm:text-base">⚠️注意：如包裝物資上有膠紙請先清理乾淨</p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">7️⃣Bubble紙，生果網袋，填充物</p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️呢類包裝物資未必可以直接回收，Guru回收番嚟重用，令佢哋有多一次，甚至更多次既生命
                    </p>
                    <p className="mt-2 text-sm sm:text-base">⚠️注意：如包裝物資上有膠紙請先清理乾淨</p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">
                      8️⃣環保袋，不織布袋，紙袋，膠袋 (任何類型，品牌，大細，無爛都收，必需要乾淨)
                    </p>
                    <p className="mt-2 text-sm sm:text-base">
                      ‼️呢類袋好多時無得直接回收，Guru回收番嚟重用，令佢哋有多一次，甚至更多次既生命
                    </p>
                    <p className="mt-2 text-sm sm:text-base">⚠️注意：如包裝物資上有膠紙請先清理乾淨</p>
                  </div>

                  <div>
                    <p className="font-semibold text-sm sm:text-base">9️⃣隱形眼鏡殼 (任何類型，品牌，必需要乾淨及晾乾)</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">⚠️注意事項：</h3>
                <ol className="list-decimal pl-6 sm:pl-8 space-y-2 text-sm sm:text-base">
                  <li>回收上限為5kg而不多於兩箱/袋(因為司機車中還有其他貨物，而且亦需要預留空間俾其他客人做回收)</li>
                  <li>所有回收都必須清潔乾淨及妥善放好入箱/袋，如未處理好，運輸有權拒絕回收，而顧客不得追討任何損失。</li>
                </ol>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">打雜有話兒：</h3>
                <p className="mt-2 text-sm sm:text-base">
                  我哋好歡迎大家俾物資比我哋重用，但為左可以減低回收嘅程序，時間，人手及炭排放，任何類型回收，只可以跟環保配送一齊送返公司，而且必須買滿$450就可以一次過俾埋司機送回公司。
                </p>

                <p className="mt-4 text-sm sm:text-base">
                  瓹窿瓹罅背後無財團，無正苦資助，更加無收任何捐款，打雜只係靠onlineshop既薄利去實踐我哋既理念，希望大家明白環保係需要資金既，如果你都認同我哋既理念，Guru超過
                  2000款產品，不妨睇吓有無嘢啱買，試吓我哋既「環保配送服務」，多謝支持環保♻️
                </p>

                <p className="mt-4 text-sm sm:text-base">
                  因為環保回收係需要資金的。瓹窿瓹罅有俾錢司機再車返公司，而且回收品會佔用貨van嘅位置，佢唔可以再車其他嘢開工搵錢，多左功夫，所以當中嘅開資係由賺到嘅利潤去支持，而且每星期我哋都會不少於一次安排大車送回收物到喵坊及其他回收商，另外回收品的倉存等等。香港人工，車費非常昂貴，瓹窿瓹罅又唔會要司機白做（打雜嘅人工同時間係心甘情願的，就唔好計埋入去了）。現實話俾大家知，希望大家明白如果只購物$300包埋送貨，甚至無條件接收物資，係無辨法營運到整個環保配送服務！
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">咁可以自己拎回收上嚟嗎？</h3>
                <p className="mt-2 text-sm sm:text-base">我哋暫時只會靠「環保配送服務」去回收物資，暫時都唔會接受自携回收.</p>

                <p className="mt-4 text-sm sm:text-base">
                  原因係人手及空間不足，如果開放自携回收，我哋控制唔到有幾多人拎回收上嚟，如果一下子有好多人拎上嚟，我哋無足夠空間同人手去應付.
                  但經「環保配送服務」我哋可以因應客人落單既量去安排倉位，我哋亦可以集中一個時間去處理回收。多謝體諒🥺
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component
const Main = () => {
  return (
    <div className="w-full bg-white">
      <RecycleContent />
    </div>
  );
};

// Page component
export default function RecyclePage() {
  return (
    <MainLayout title="回收須知 | GuruGuruHK" url="/article/recycle">
      <Main />
    </MainLayout>
  );
}
